import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneNumber', standalone: false })
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');
    const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

    if (national.length === 10) {
      return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
    }

    // not a standard 10-digit number: show as entered
    return value;
  }
}